module.exports = __webpack_public_path__ + "img/body-2.694f33af.png";